import { render } from "./TrainerListEditDrawer2.vue?vue&type=template&id=41e23060&ts=true"
import script from "./TrainerListEditDrawer2.vue?vue&type=script&lang=ts"
export * from "./TrainerListEditDrawer2.vue?vue&type=script&lang=ts"

import "./TrainerListEditDrawer2.vue?vue&type=style&index=0&id=41e23060&lang=css"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__